export class OnBoardingVideo {
  title!: string;
  url!: string;
  thumbnail!: string;
}
